import React, { useState, createContext } from "react";
import Login from "./components/Login";
import MainScreenContainer from "./MainScreenContainer";
import { DEFAULT_APP_STATE, defaultScriptsContext } from "./constants";

// Create a context object
export const AppMainContext = createContext();
// Create a context object for scripts
export const ScriptsContext = createContext();

const App = () => {
  const [appContext, setAppContext] = useState(DEFAULT_APP_STATE);
  const [scriptsContext, setScriptsContext] = useState(defaultScriptsContext);
  return (
    <AppMainContext.Provider value={{ appContext, setAppContext }}>
      <ScriptsContext.Provider value={{ scriptsContext, setScriptsContext }}>
        {!appContext.user ? <Login /> : <MainScreenContainer />}
      </ScriptsContext.Provider>
    </AppMainContext.Provider>
  );
};

export default App;
